"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { createContext, useContext } from 'react';

const NestedComboBoxContext = createContext(null);
function useNestedComboBox() {
  const component = useContext(NestedComboBoxContext);
  if (!component) {
    throw new Error("useNestedComboBox must be used within NestedComboBoxProvider");
  }
  return component;
}

export { NestedComboBoxContext, useNestedComboBox };
